import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { craneDocsAPI } from '@/lib/api';

const fmt = (d) => new Date(d).toLocaleDateString('en-IN');

export const ExpiringDocsBox = () => {
  const [docs, setDocs] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { craneDocsAPI.expiring().then((r) => setDocs(r.data)).catch(() => {}); }, []);
  if (docs.length === 0) return null;
  return (
    <div className="border-2 border-amber-300 bg-amber-50 dark:bg-amber-950/30 rounded-lg p-4" data-testid="expiring-docs-box">
      <p className="font-bold text-amber-800 dark:text-amber-300 flex items-center gap-2 mb-2">
        <AlertTriangle className="w-4 h-4" /> Crane documents expiring ({docs.length})
      </p>
      <div className="space-y-1">
        {docs.map((d) => {
          const expired = d.status.state === 'expired';
          return (
            <button type="button" key={d.id} onClick={() => navigate('/cranes')} data-testid={`expiring-doc-${d.id}`}
              className="w-full flex flex-wrap items-center justify-between gap-2 text-sm bg-background/70 hover:bg-background rounded px-3 py-1.5 text-left">
              <span><span className="font-semibold">{d.equipment}</span> <span className="text-muted-foreground">({d.serial_number})</span> · {d.doc_type}</span>
              <span className={`text-xs font-bold ${expired ? 'text-red-600' : 'text-amber-700'}`}>
                {expired ? `Expired ${fmt(d.expiry_date)}` : d.status.days_left === 0 ? 'Expires today' : `Expires ${fmt(d.expiry_date)} (${d.status.days_left}d)`}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
